import env from 'enviro';
import { CHECKOUT_INTERSTITIAL_UI_GATE, RECOMMENDED_VIEW, TRIAL_PURCHASE_MOTION_CTA, UNIFIED_CART_EXPERIMENT_GATE } from '../constants/Gates';
import { SEATS_VERSIONS_FEATURE_FLAG } from '../constants/PublicFeatureFlags';
import { SEATS_ACCESS } from '../constants/Scopes';
import { hasAnyMarketingPlusSkuInProductData, hasBreezeIntelligenceSkusInProductData } from './productsUtils';
import { getIsQAProxy } from './proxyUtils';
import safeLocalStorage from './safeLocalStorage';
export const getIsUngated = (state, {
  gateKey
}) => {
  const {
    gates
  } = state;
  const isQA = env.isQa() || getIsQAProxy();
  const override = safeLocalStorage.getItem(`${gateKey}_OVERRIDE`);
  if (override === 'true' && isQA) {
    return true;
  }
  return gates === null || gates === void 0 ? void 0 : gates.includes(gateKey);
};
export const getIsUngatedForSeats = state => {
  const isUngatedByPublicFlagOrOverride = getIsUngated(state, {
    gateKey: SEATS_VERSIONS_FEATURE_FLAG
  });
  const urlParams = new URLSearchParams(window.location.search);
  const isUngatedByQueryParamOverride = urlParams.get('forceSeatsPricing') === 'true';
  const isUngatedOnPublic = isUngatedByPublicFlagOrOverride || isUngatedByQueryParamOverride;
  return isUngatedOnPublic || getIsUngated(state, {
    gateKey: SEATS_ACCESS
  });
};
export const getAreGatesPopulated = state => {
  return state.gates.length > 0;
};
export const getIsUngatedForMarketingPlus = state => {
  return hasAnyMarketingPlusSkuInProductData(state);
};
export const getIsUngatedForBreezeIntelligence = state => {
  return hasBreezeIntelligenceSkusInProductData(state);
};
export const getIsUngatedForCheckoutInterstitialUI = state => {
  return getIsUngated(state, {
    gateKey: CHECKOUT_INTERSTITIAL_UI_GATE
  });
};
export const getIsUngatedForUnifiedCartExperiment = state => getIsUngated(state, {
  gateKey: UNIFIED_CART_EXPERIMENT_GATE
});
export const getIsUngatedForMTVTrialPurchaseMotion = state => getIsUngated(state, {
  gateKey: TRIAL_PURCHASE_MOTION_CTA
});
export const getIsUngatedForRecommendedView = state => getIsUngated(state, {
  gateKey: RECOMMENDED_VIEW
});